// extracted by mini-css-extract-plugin
module.exports = {"streetWithHousenr":"AddressWidget_streetWithHousenr__1LL20","AddressWidget":"AddressWidget_AddressWidget__oeIN-"};